<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/agents">Agents</router-link>
                    </li>
                    <template v-if="!agent.id">
                        <vue-headful :title="'Create Agent - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Agent] ' + agent.first_name + ' '+agent.last_name+' - AMOS365'" />

                        <li class="breadcrumb-item">
                            <router-link :to="`/agents/view/${agent.id}`">{{ agent.first_name }} {{ agent.last_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ agent.first_name }} {{ agent.last_name }}</span>
                <span v-else>New Agent</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.first_name, 'text-muted-no': !errors.first_name}">
                                    First Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!agent.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.first_name" :class="{'form-control': true, 'is-invalid': errors.first_name}" placeholder="Enter Agent First Name" />

                                    <div class="text-danger mt-2" v-if="errors.first_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.first_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.last_name, 'text-muted-no': !errors.last_name}">
                                    Last Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!agent.last_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.last_name" :class="{'form-control': true, 'is-invalid': errors.last_name}" placeholder="Enter Agent Last Name" />

                                    <div class="text-danger mt-2" v-if="errors.last_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.last_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.middle_name, 'text-muted-no': !errors.middle_name}">Middle Name:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.middle_name" :class="{'form-control': true, 'is-invalid': errors.middle_name}" placeholder="Enter Agent Middle Name" />

                                    <div class="text-danger mt-2" v-if="errors.middle_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.middle_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.nickname, 'text-muted-no': !errors.nickname}">Nickame:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.nickname" :class="{'form-control': true, 'is-invalid': errors.nickname}" placeholder="Enter Nickname" />

                                    <div class="text-danger mt-2" v-if="errors.nickname">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.nickname">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.suffix, 'text-muted-no': !errors.suffix}">Suffix:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.suffix" :class="{'form-control': true, 'is-invalid': errors.suffix}" placeholder="Enter Suffix" style="max-width: 100px;" />

                                    <div class="text-danger mt-2" v-if="errors.suffix">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.suffix">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.gender, 'text-muted-no': !errors.gender}">Gender:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-radio-group v-model="agent.gender" name="gender" plain>
                                        <b-form-radio value="Male">Male</b-form-radio>
                                        <b-form-radio value="Female">Female</b-form-radio>
                                    </b-form-radio-group>

                                    <div class="text-danger mt-2" v-if="errors.gender">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.gender">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="agent.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_prospect, 'text-muted-no': !errors.is_prospect}">Prospective:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="agent.is_prospect" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_prospect">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_prospect">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_do_not_contact, 'text-muted-no': !errors.is_do_not_contact}">Do Not Contact:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="agent.is_do_not_contact" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_do_not_contact">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_do_not_contact">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="agent.is_do_not_contact == 1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.dnc_code_id, 'text-muted-no': !errors.dnc_code_id}">
                                    Do Not Contact Code: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="agent.dnc_code_id" :options="dncCodes" />

                                    <div class="text-danger mt-2" v-if="errors.dnc_code_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.dnc_code_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_do_not_contact_downline, 'text-muted-no': !errors.is_do_not_contact_downline}">Do Not Contact Downline:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="agent.is_do_not_contact_downline" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_do_not_contact_downline">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_do_not_contact_downline">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="agent.is_do_not_contact_downline == 1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.dnc_downline_code_id, 'text-muted-no': !errors.dnc_downline_code_id}">
                                    Do Not Contact Downline Code:  <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="agent.dnc_downline_code_id" :options="dncCodes" />

                                    <div class="text-danger mt-2" v-if="errors.dnc_downline_code_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.dnc_downline_code_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.agency_name, 'text-muted-no': !errors.agency_name}">Agency:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <v-select
                                        v-model="agent.agency_id"
                                        :options="agencies"
                                        :reduce="agency => agency.id"
                                        label="agency_name"
                                        :class="{'is-invalid': errors.agency_id}"
                                        placeholder="-- Select an Agency --" />

                                    <div class="text-danger mt-2" v-if="errors.agency_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.agency_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.master_level, 'text-muted-no': !errors.master_level}">
                                    Master Level:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.master_level" :class="{'form-control': true, 'is-invalid': errors.master_level}" placeholder="Enter Default Master Level" />

                                    <div class="text-danger mt-2" v-if="errors.master_level">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.master_level">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.marketer_id, 'text-muted-no': !errors.marketer_id}">
                                    Marketer:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <v-select
                                        v-model="agent.marketer_id"
                                        :options="marketer_agents"
                                        :reduce="agent => agent.id"
                                        label="agent_name"
                                        :class="{'is-invalid': errors.marketer_id}"
                                        placeholder="-- Select a Marketer --"
                                        @search="searchMarketerAgents"
                                        :filterable="false" />

                                    <div class="text-danger mt-2" v-if="errors.marketer_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.marketer_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.marketer_date_assigned, 'text-muted-no': !errors.marketer_date_assigned}">
                                    Date Marketer Assigned:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="agent.marketer_date_assigned" :class="{'form-control': true, 'is-invalid': errors.marketer_date_assigned}" />

                                    <div class="text-danger mt-2" v-if="errors.marketer_date_assigned">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.marketer_date_assigned">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="marketerCodes.length > 0">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.marketer_code_id, 'text-muted-no': !errors.marketer_code_id}">
                                    Marketer Relationship Code:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-radio v-model="agent.marketer_code_id" name="marketer_code_id" :value="null" plain>
                                        -- None --
                                    </b-form-radio>
                                    <b-form-radio v-model="agent.marketer_code_id" name="marketer_code_id" :value="code.id" plain v-for="code in marketerCodes" :key="code.id">
                                        {{ code.marketer_code_label }} <i class="fa fa-question-circle" :id="`marketer-rel-code-${code.id}`"></i>
                                        <b-tooltip :target="`marketer-rel-code-${code.id}`" triggers="hover" placement="right">
                                            <span v-html="$sanitize(code.marketer_code_desc)"></span>
                                        </b-tooltip>
                                    </b-form-radio>

                                    <div class="text-danger mt-2" v-if="errors.marketer_code_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.marketer_code_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Management</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.direct_manager_type, 'text-muted-no': !errors.direct_manager_type}">
                                    Direct Upline Manager Type:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-radio-group v-model="agent.direct_manager_type" name="direct_manager_type" plain>
                                        <b-form-radio value="Agency">Agency</b-form-radio>
                                        <b-form-radio value="Agent">Agent</b-form-radio>
                                        <b-form-radio :value="null">N/A</b-form-radio>
                                    </b-form-radio-group>

                                    <div class="text-danger mt-2" v-if="errors.direct_manager_type">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.direct_manager_type">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': (errors.direct_manager_id), 'text-muted-no': !(errors.direct_manager_id)}">
                                    Direct Upline Manager:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">

                                    <v-select
                                        v-if="agent.direct_manager_type === 'Agency'"
                                        v-model="direct_manager_id_agency"
                                        :options="agencies"
                                        :reduce="agency => agency.id"
                                        label="agency_name"
                                        :class="{'is-invalid': errors.direct_manager_id_agency}"
                                        placeholder="-- Select an Agency --" />

                                    <v-select
                                        v-if="agent.direct_manager_type === 'Agent'"
                                        v-model="direct_manager_id_agent"
                                        :options="direct_agents"
                                        :reduce="agent => agent.id"
                                        label="agent_name"
                                        :class="{'is-invalid': errors.direct_manager_id}"
                                        placeholder="-- Select an Agent --"
                                        @search="searchDirectManagerAgents"
                                        :filterable="false" />

                                    <span v-if="!agent.direct_manager_type">-- Select Direct Upline Manager Type --</span>

                                    <div class="text-danger mt-2" v-if="errors.direct_manager_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.direct_manager_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.top_manager_type, 'text-muted-no': !errors.top_manager_type}">
                                    Affiliation Manager Type:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-radio-group v-model="agent.top_manager_type" name="top_manager_type" plain>
                                        <b-form-radio value="Agency">Agency</b-form-radio>
                                        <b-form-radio value="Agent">Agent</b-form-radio>
                                        <b-form-radio :value="null">N/A</b-form-radio>
                                    </b-form-radio-group>

                                    <div class="text-danger mt-2" v-if="errors.top_manager_type">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.top_manager_type">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': (errors.top_manager_id), 'text-muted-no': !(errors.top_manager_id)}">
                                    Affiliation Manager:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">

                                    <v-select
                                        v-if="agent.top_manager_type === 'Agency'"
                                        v-model="top_manager_id_agency"
                                        :options="agencies"
                                        :reduce="agency => agency.id"
                                        label="agency_name"
                                        :class="{'is-invalid': errors.top_manager_id}"
                                        placeholder="-- Select an Agency --" />

                                    <v-select
                                        v-if="agent.top_manager_type === 'Agent'"
                                        v-model="top_manager_id_agent"
                                        :options="top_agents"
                                        :reduce="agent => agent.id"
                                        label="agent_name"
                                        :class="{'is-invalid': errors.top_manager_id}"
                                        placeholder="-- Select an Agent --"
                                        @search="searchUplineManagerAgents"
                                        :filterable="false" />

                                    <span v-if="!agent.top_manager_type">-- Select Affiliation Manager Type --</span>

                                    <div class="text-danger mt-2" v-if="errors.top_manager_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.top_manager_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Identification:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3" v-if="$root.hasPermission('agents.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.ssn, 'text-muted-no': !errors.ssn}">SSN:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <the-mask :mask="'XXX-XX-XXXX'" v-model="agent.ssn" :class="{'form-control': true, 'is-invalid': errors.ssn}" placeholder="Enter SSN" />

                                    <div class="text-danger mt-2" v-if="errors.ssn">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.ssn">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="$root.hasPermission('agents.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.date_of_birth, 'text-muted-no': !errors.date_of_birth}">Date of Birth:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="agent.date_of_birth" :class="{'form-control': true, 'is-invalid': errors.date_of_birth}" placeholder="Enter Agent Date of Birth" />

                                    <div class="text-danger mt-2" v-if="errors.date_of_birth">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.date_of_birth">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.npn, 'text-muted-no': !errors.npn}">
                                    NPN: <i class="fa fa-sm fa-asterisk text-danger" v-if="!agent.npn"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.npn" :class="{'form-control': true, 'is-invalid': errors.npn}" placeholder="Enter Agent NPN" />

                                    <div class="text-danger mt-2" v-if="errors.npn">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.npn">
                                                <span v-if="typeof err === 'object'">
                                                    {{ err.msg }} View Agent: <router-link :to="`/agents/view/${err.agent.id}`">{{ err.agent.first_name }} {{ err.agent.last_name }}</router-link>
                                                </span>
                                                <span v-else>{{ err }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="$root.hasPermission('agents.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.tax_id, 'text-muted-no': !errors.tax_id}">Tax ID:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <the-mask :mask="'##-#######'" v-model="agent.tax_id" :class="{'form-control': true, 'is-invalid': errors.tax_id}" placeholder="Enter Tax ID" />

                                    <div class="text-danger mt-2" v-if="errors.tax_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.tax_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.res_state_id, 'text-muted-no': !errors.res_state_id}">Resident State:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="agent.res_state_id" :options="stateOptions" size="sm" />

                                    <div class="text-danger mt-2" v-if="errors.res_state_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.res_state_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.res_license_nbr, 'text-muted-no': !errors.res_license_nbr}">Res. License#:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="agent.res_license_nbr" :class="{'form-control': true, 'is-invalid': errors.res_license_nbr}" placeholder="Enter Resident License#" />

                                    <div class="text-danger mt-2" v-if="errors.res_license_nbr">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.res_license_nbr">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.ahip, 'text-muted-no': !errors.ahip}">AHIP:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="agent.ahip" :class="{'form-control': true, 'is-invalid': errors.ahip}" placeholder="Enter AHIP" />

                                    <div class="text-danger mt-2" v-if="errors.ahip">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.ahip">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.eo_expiration, 'text-muted-no': !errors.eo_expiration}">EO Expiration:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="agent.eo_expiration" :class="{'form-control': true, 'is-invalid': errors.eo_expiration}" placeholder="Enter EO Expiration" />

                                    <div class="text-danger mt-2" v-if="errors.eo_expiration">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.eo_expiration">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            <b-form-textarea v-model="agent.notes" :class="{'is-invalid': errors.notes}" placeholder="Enter Agent Notes" rows="3"></b-form-textarea>
                        </div>
                    </div>

                    <files-add ref="agentEditFiles" :rowClass="'col-lg-4 col-md-6 col-12'" :sensitive="true" />
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Email ({{ emails.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.emailEditor.addEmail()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <email-editor ref="emailEditor" :emails="emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Phone Numbers ({{ phones.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.phoneEditor.addPhone()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <phone-editor ref="phoneEditor" :phones="phones" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Address ({{ addresses.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.addressEditor.addAddress()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <address-editor ref="addressEditor" :addresses="addresses" :states="states" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveAgent()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveAgent()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask';

    export default {
        components: {TheMask},
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                agent: {},
                errors: {},
                states: [],
                addresses: [],
                emails: [],
                phones: [],
                agencies: [],
                files: [],
                codes: [],
                marketerCodes: [],

                top_agents: [],
                direct_agents: [],
                marketer_agents: [],
                direct_manager_id_agency: null,
                top_manager_id_agency: null,
                direct_manager_id_agent: null,
                top_manager_id_agent: null,
            }
        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },

            dncCodes(){
                //Setup
                var options = [{value: null, text: '-- Select a DNC Code --'}];

                //Main Loop
                for(var i = 0; i < this.codes.length; i++)
                {
                    options.push({value: this.codes[i].id, text: this.codes[i].dnc_code_reason});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getAgent(){
                //Send it
                this.$http.get('/agents/edit' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set the agent
                        this.agent = response.data.agent;
                        this.agencies = response.data.agencies;
                        this.addresses = response.data.addresses;
                        this.emails = response.data.emails;
                        this.phones = response.data.phones;
                        this.states = response.data.states;
                        this.codes = response.data.codes;
                        this.marketerCodes = response.data.marketerCodes;

                        //Check the agent for some values
                        if(this.agent.direct_manager_type)
                        {
                            //IF it's an agent, we have to set the value
                            if(this.agent.direct_manager_type === 'Agent' && this.agent.direct_manager)
                            {
                                this.direct_agents.push({id: this.agent.direct_manager_id, agent_name: (this.agent.direct_manager.first_name + ' ' + this.agent.direct_manager.last_name)});
                            }

                            //Set the ID
                            this['direct_manager_id_' + this.agent.direct_manager_type.toLowerCase()] = this.agent['direct_manager_id'];
                        }

                        //Check Affiliate Manager
                        if(this.agent.top_manager_type)
                        {
                            //IF it's an agent, we have to set the value
                            if(this.agent.top_manager_type === 'Agent' && this.agent.top_manager)
                            {
                                //Push the Agent Record
                                this.top_agents.push({id: this.agent.top_manager_id, agent_name: (this.agent.top_manager.first_name + ' ' + this.agent.top_manager.last_name)});
                            }

                            //Set the ID
                            this['top_manager_id_' + this.agent.top_manager_type.toLowerCase()] = this.agent['top_manager_id'];
                        }

                        //Check Affiliate Manager
                        if(this.agent.marketer_id)
                        {
                            //Push it
                            this.marketer_agents.push({id: this.agent.marketer_id, agent_name: this.agent.marketer_name});
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveAgent(){
                //Helpers
                this.saving = true;
                this.errors = {};
                this.$refs.emailEditor.setErrors({});
                this.$refs.phoneEditor.setErrors({});
                this.$refs.addressEditor.setErrors({});

                //Append Stuff to the Payload
                this.agent.emails = this.$refs.emailEditor.getEmails();
                this.agent.phones = this.$refs.phoneEditor.getPhones();
                this.agent.addresses = this.$refs.addressEditor.getAddresses();

                //Set Some Types
                if(this.agent.direct_manager_type === 'Agency')
                {
                    //Set the ID
                    this.agent.direct_manager_id = this.direct_manager_id_agency;
                }
                else if (this.agent.direct_manager_type === 'Agent')
                {
                    //Set the ID
                    this.agent.direct_manager_id = this.direct_manager_id_agent;
                }
                else
                {
                    this.agent.direct_manager_id = null;
                }

                //Set Some Types
                if(this.agent.top_manager_type === 'Agency')
                {
                    //Set the ID
                    this.agent.top_manager_id = this.top_manager_id_agency;
                }
                else if (this.agent.top_manager_type === 'Agent')
                {
                    //Set the ID
                    this.agent.top_manager_id = this.top_manager_id_agent;
                }
                else
                {
                    this.agent.top_manager_id = null;
                }

                //Get it
                var file_data = this.$refs.agentEditFiles.getFilesForSave();

                //Set
                this.agent.file_names = file_data.file_names;
                this.agent.file_sensitive = file_data.file_sensitive;

                //Send it
                this.$http
                .postWithFiles('agents/save', this.agent, file_data.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Agent ' + (this.agent.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/agents/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the Errors on the Contact Resources
                        this.$refs.phoneEditor.setErrors(this.errors);
                        this.$refs.emailEditor.setErrors(this.errors);
                        this.$refs.addressEditor.setErrors(this.errors);

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Agent');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            addAddress(){
                //Push
                this.addresses.push({address: '', city: '', state_id: null, zip: '', is_primary: 0});
            },

            deleteAddress(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this address: '+this.addresses[i].address))
                {
                    return;
                }

                //Splice
                this.addresses.splice(i, 1);
            },

            addEmail(){
                //Push
                this.emails.push({email: '', is_primary: 0});
            },

            deleteEmail(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this email: '+this.emails[i].email))
                {
                    return;
                }

                //Splice
                this.emails.splice(i, 1);
            },

            addPhone(){
                //Push
                this.phones.push({phone: '', is_primary: 0, phone_type: null});
            },

            deletePhone(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this phone number: '+this.phones[i].phone))
                {
                    return;
                }

                //Splice
                this.phones.splice(i, 1);
            },

            searchAgencies(search, loading, agent_type){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'agencies.agency_name',
                    typeahead: true,
                };

                //Show a Loading INdicator?
                this.$http.get('/agencies', payload)
                        .then(response => {
                            //Stop Loading indicator
                            loading(false);

                            // //Set the values
                            this.agencies = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        });
            },

            searchUplineManagerAgents(search, loading){
                //Wrapper since we cannot pass in extra variables to the VueSelect handler
                this.searchAgents(search, loading, 'top');
            },

            searchDirectManagerAgents(search, loading){
                //Wrapper since we cannot pass in extra variables to the VueSelect handler
                this.searchAgents(search, loading, 'direct');
            },

            searchMarketerAgents(search, loading){
                //Wrapper since we cannot pass in extra variables to the VueSelect handler
                this.searchAgents(search, loading, 'marketer');
            },

            searchAgents(search, loading, agent_type){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 50,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'agents.last_name',
                    typeahead: true,
                    filters: {
                        'agents.is_active': 1,
                    },
                };

                //Show a Loading INdicator?
                this.$http.get('/agents', payload)
                        .then(response => {
                            loading(false);

                            // //Set the Data
                            // var agents = response.data.data;

                            // //Loop and Build
                            // for (var i = 0; i < response.data.data.length; i++)
                            // {
                            //     agents.push({id: response.data.data[i].id, agent_name: (response.data.data[i].first_name + ' ' + response.data.data[i].last_name)})
                            // }

                            // //Set the values
                            this[agent_type+'_agents'] = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        })
            }
        },

        mounted() {
            //get the agent?
            this.getAgent();
        }
    }
</script>
